<template>
  <div class="h-100">
    <div v-if="showStep===steps.PAYMENT" class="h-100">

      <div class="match-card match-card__empty-joker text-center">
        <div class="title title--large title--white">
          {{ responseMessage }}
          {{ trans.get('pages:match_game.jokers_empty_card.header') }}
        </div>
        <div class="desc desc--white">
          {{ trans.get('pages:match_game.jokers_empty_card.desc') }}
        </div>
        <div class="empty-joker__image my-4">
          <div class="avatar-single avatar-single--circle avatar-single--border-one" :style="{'background-image':'url(' + user.web_avatar_url + ')'}">
          </div>
        </div>

        <div class="mt-2">
          <router-link :to="{name: 'payment', params: {unit: 'jokers'}}" class="button button__outline button__outline--white-hov-purple">
            {{ trans.get('pages:match_game.jokers_empty_card.go_to_shop_button') }}
          </router-link>
          <div class="mt-2">
            <button v-on:click="emitCancel()" class="button button__link--underline button__link--white">{{ trans.get('pages:match_game.jokers_empty_card.skip_button') }}</button>
          </div>
        </div>
      </div>
    </div>

    <div v-else-if="showStep===steps.MESSAGE" class="h-100">
        <div class="match-card-close">
            <button v-on:click="emitNext()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
      <div class="match-card match-card__match text-center">
        <div class="match-card__desc">
          <div class="title title--big title--white title--font-secondary">
            {{ responseMessage || trans.get('pages:match_game.api.match') }}
          </div>
          <div class="desc desc--white mt-1">
            {{ trans.get('pages:match_game.match_card.header') }}
          </div>
        </div>

        <div class="avatar-with-avatar">
          <div class="avatar-with-avatar__first heartbeat" :style="{'background-image':'url(' + user.web_avatar_url + ')'}"></div>
          <div class="avatar-with-avatar__second heartbeat" :style="{'background-image':'url(' + current.profile.avatar_url + ')'}"></div>
        </div>

        <div class="match-card__info">
          <div class="desc desc--white">
            {{ trans.get('pages:match_game.match_card.you_and') }}
            <strong>{{ current.profile.name }}</strong>
            {{ trans.get('pages:match_game.match_card.have_similar_minds') }}
          </div>
        </div>

        <div class="match-card__form">
          <div class="d-flex align-items-center">
            <div class="flex-grow-1 pr-2">
              <input v-model="message" type="text" class="input-text input-text__fill input-text__fill--white" minlength="3">
            </div>
            <button v-on:click="messageStepAction()" class="button button__outline button__outline--white-hov-purple">{{ trans.get('pages:match_game.match_card.send_button') }}</button>
          </div>
        </div>

        <div class="mmatch-card__button">
          <button v-on:click="emitNext()" class="button button__link--underline button__link--white text-bold">{{ trans.get('pages:match_game.match_card.keep_looking_button') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  name: 'JokerCard',
  props: {
    value: Object,
    current: Object,
  },
  data() {
    return {
      responseMessage: null,
      showStep: 'MESSAGE',
      steps: {
        PAYMENT: 'PAYMENT',
        MESSAGE: 'MESSAGE',
      },
      paymentApproval: false,
      message: null,
    };
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
      isPaymentApproved: 'isPaymentApproved',
    }),
  },
  methods: {
    emitSkip() {
      this.$emit('input', { visible: false, });
      this.$emit('skip', 'SKIP');
    },
    emitCancel() {
      this.$emit('input', { visible: false, });
    },
    emitNext() {
      this.$emit('input', { visible: false, });
      this.$emit('next', 'NEXT');
    },
    messageStepAction() {
      return axios
        .post(zRoute('ajax.match_game.joker_message', this.current.profile.id), {
          message: this.message,
        })
        .then(response => {
          if (response.data.status === 'success') {
            this.showStep = this.steps.MESSAGE;
            this.emitNext();
          }
          this.responseMessage = response.data.message;
        });

    },
  },
  mounted() {
    //  this.defaultStepAction();
  }
};
</script>


